import { Tooltip, TooltipContent, TooltipTrigger } from "@skailer-com/uikit";
import { useEffect, useRef, useState } from "react";

// Tooltip only when the text is actually clamped (vertical overflow)
export function TruncatedText({ text }: { text: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const id = window.requestAnimationFrame(() =>
      setIsTruncated(el.scrollHeight > el.clientHeight + 1)
    );
    return () => window.cancelAnimationFrame(id);
  }, [text]);

  return (
    <Tooltip delay={false} open={isTruncated ? undefined : false}>
      <TooltipTrigger asChild>
        <div ref={ref} className="text-secondary line-clamp-2">
          {text}
        </div>
      </TooltipTrigger>
      <TooltipContent className="max-w-80">{text}</TooltipContent>
    </Tooltip>
  );
}
